import { observer } from 'mobx-react-lite';

import { LargeCallAvatar } from '@gem/call/CallView/Shared/Avatars/LargeCallAvatar/LargeCallAvatar';
import { IcPhone32Icon, IcCancelCallIcon } from '@gem/icons';
import { AddKeyPressHandler } from '@gem/keyboard-handler';
import { useTranslation } from '@gem/modules/i18n';
import { IconButton, IconViewSizes, OverlayingPopup } from '@gem/ui-kit';

import { AutoplayingLoopAudio } from 'APP/components/AutoplayingLoopAudio/AutoplayingLoopAudio';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import callingSound from 'ASSETS/sound/ringtone.mp3';

import { useIncomingCallPresenter } from './IncomingCall.presenter';
import styles from './IncomingCall.styles.m.css';

export const IncomingCall = observer(() => {
  const presenter = useIncomingCallPresenter();
  const { t } = useTranslation();

  if (!presenter.hasCall || presenter.group?.muted) {
    return null;
  }

  console.log('INCOMING_CALL', '5 IncomingCall show popup');
  return (
    <OverlayingPopup
      popupClassName={styles.container}
      isOpened
    >
      <div className={styles.content}>
        <AddKeyPressHandler onEsc={presenter.decline} />
        <LargeCallAvatar avatar={presenter.avatar} />

        <div className={styles.groupTitle}>{presenter.callTitle}</div>
        <div className={styles.callingState}>{t('calls_incoming_call_status')}</div>

        <div className={styles.actionsPanel}>
          <IconButton
            dataTest={'incoming-call-popup-decline-button'}
            size={IconViewSizes.XLarge}
            theme="9"
            Icon={IcCancelCallIcon}
            className={styles.button}
            onClick={presenter.decline}
          />
          <IconButton
            dataTest={'incoming-call-popup-answer-button'}
            size={IconViewSizes.XLarge}
            theme="10"
            Icon={IcPhone32Icon}
            className={styles.button}
            onClick={presenter.joinToCall}
          />
        </div>
        <AutoplayingLoopAudio
          src={callingSound}
          permissionText={t('calls_hear_incoming_call')}
        />
      </div>
    </OverlayingPopup>
  );
});
